module.exports = __webpack_public_path__ + "static/img/1_4_2.d2344e8d.jpg";